import { render } from "./SpecialitiesComponents.vue?vue&type=template&id=160c5080&scoped=true"
import script from "./SpecialitiesComponents.vue?vue&type=script&lang=js"
export * from "./SpecialitiesComponents.vue?vue&type=script&lang=js"

import "./SpecialitiesComponents.vue?vue&type=style&index=0&id=160c5080&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-160c5080"

export default script